module.exports = __webpack_public_path__ + "img/1 (92).8ca5f726.png";